<template>
  <div class="u-pad-y-sm u-pad-x-sm u-wrapper-panel u-bg-main-color u-middle u-flex u-column u-between">
    <div class="u-full-width">
      <div class="u-row u-between">
        <div class="u-w3of12">
          <router-link class="header__logo u-block" :to="{name: 'Homepage'}">
            <img src="/images/logo.jpg" class="u-full-width u-block">
          </router-link>
        </div>
        <div class="u-w3of12 u-right">
          <app-button-round
            @click="$emit('close')"
            svg="cross"
            :ghost="true"
          />
        </div>
      </div>
      <div class="u-pad-t-sm">
        <div class="u-marg-t-md u-white t-h1 u-cursor-pointer" @click="$emit('navigation')">
          Recherche
        </div>
        <template v-for="page in pages">
          <div
            role="link"
            class="u-marg-t-md u-white t-h1 u-cursor-pointer"
            @click="$emit('page', page.name)"
          >
            {{ page.title }}
          </div>
        </template>
      </div>
    </div>
    <div class="u-full-width">
      <div class="u-white t-h2 u-marg-b-sm">
        Partager
      </div>
      <socials display="between" :squared="true" />
    </div>
  </div>
</template>

<script>
import AppButtonRound from '@/components/common/AppButtonRound'
import Socials from '@/components/common/Socials'

export default {
  components: {
    AppButtonRound,
    Socials
  },

  computed: {
    pages () {
      return this.$store.getters['pages/annexes']
    }
  },

  watch: {
    $route () {
      this.$emit('close')
    }
  },

  mounted () {
    this.$ga.send('navigation', 'about', 'open')
  },

  beforeUnmount () {
    this.$ga.send('navigation', 'about', 'close')
  }
}
</script>

<style lang="stylus">
  
</style>